import { render, staticRenderFns } from "./MapDetailCard.vue?vue&type=template&id=2d9706f4&scoped=true"
import script from "./MapDetailCard.vue?vue&type=script&lang=js"
export * from "./MapDetailCard.vue?vue&type=script&lang=js"
import style0 from "./MapDetailCard.vue?vue&type=style&index=0&id=2d9706f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9706f4",
  null
  
)

export default component.exports